/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { Linkable } from '@/components/blocks/Linkable';
import {
	myPagesMenuButtonGroupSX,
	myPagesMenuButtonSX,
	myPagesMenuWrapperSX,
} from '@/components/content/Header/styles/myPagesMenu';
import { useLogout } from '@/data/Content/Logout';
import { useLocalization } from '@/data/Localization';
import { useUser } from '@/data/User';
import { ProjectContext } from '@/data/context/project';
import { Button, ButtonGroup, Drawer, Stack } from '@mui/material';
import { Projects } from 'presentation/components/fiwe/blocks/Projects';
import { FC, useContext, useState } from 'react';

export const MyPagesMenu: FC<{
	onVideo?: boolean;
	megaMenuOpen?: boolean;
}> = ({ onVideo, megaMenuOpen }) => {
	const AccountLabels = useLocalization('PersonalInformation');
	const HeaderLabels = useLocalization('Header');
	const { handleLogout, settings } = useLogout();
	const { user: { buyerAdmin = false } = {} } = useUser();
	const { hasProjects, currentProjectId } = useContext(ProjectContext);

	const [projectDrawer, setProjectDrawer] = useState(false);

	return (
		<Stack direction="row" justifyContent="center" sx={myPagesMenuWrapperSX(onVideo, megaMenuOpen)}>
			<ButtonGroup variant="text" color={onVideo ? 'white' : 'black'} sx={myPagesMenuButtonGroupSX}>
				<Linkable href="/dashboard" type="button" sx={myPagesMenuButtonSX}>
					{HeaderLabels.Actions.Dashboard.t()}
				</Linkable>
				<Linkable href="/order-history" type="button" sx={myPagesMenuButtonSX}>
					{HeaderLabels.Actions.Orders.t()}
				</Linkable>
				{buyerAdmin ? (
					<Linkable href="/invoices" type="button" sx={myPagesMenuButtonSX}>
						{HeaderLabels.Actions.Invoices.t()}
					</Linkable>
				) : null}
				{hasProjects ? (
					<Button onClick={() => setProjectDrawer(true)} sx={myPagesMenuButtonSX}>
						{HeaderLabels.Actions.Projects.t()}
						{currentProjectId !== null ? `: ${currentProjectId}` : null}
					</Button>
				) : null}
				<Linkable href="/account" type="button" sx={myPagesMenuButtonSX}>
					{HeaderLabels.Actions.MyAccount.t()}
				</Linkable>
				{settings?.csrSession ? null : (
					<Button onClick={handleLogout} sx={myPagesMenuButtonSX}>
						{AccountLabels.SignOutButton.t()}
					</Button>
				)}
			</ButtonGroup>
			<Drawer anchor={'right'} open={projectDrawer} onClose={() => setProjectDrawer(false)}>
				<Projects listOpen={true} setDrawerOpen={setProjectDrawer} />
			</Drawer>
		</Stack>
	);
};
